import { motion, AnimatePresence } from "framer-motion";
import { FaChevronRight, FaChevronLeft, FaQuoteRight } from "react-icons/fa";
import React from "react";

export const TestimonialSection = (props: any) => {
  const [index, setIndex] = React.useState(0);
  const [direction, setDirection] = React.useState(0);

  const next = () => {
    setDirection(1);
    setIndex((p) => (p + 1) % props.testimonialList.length);
  };

  const prev = () => {
    setDirection(-1);
    setIndex((p) => (p - 1 + props.testimonialList.length) % props.testimonialList.length);
  };

  const slideVariants = {
    enter: (dir: number) => ({
      x: dir === 1 ? 120 : -120,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (dir: number) => ({
      x: dir === 1 ? -120 : 120,
      opacity: 0,
    }),
  };

  const t = props.testimonialList[index];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">

        {/* Outer Wrapper */}
        <div className="bg-white border border-gray-200 rounded-3xl p-10 md:p-16 shadow-sm relative overflow-hidden">

          {/* Header Row */}
          <div className="flex items-start justify-between mb-12">
            <div>
              <p className="text-red-600 font-semibold tracking-[3px] uppercase text-sm mb-2">
                {props.subTitle}
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                {props.title}
              </h2>
            </div>

            <FaQuoteRight className="text-red-500 text-4xl opacity-80" />
          </div>

          {/* Main Layout Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">

            {/* LEFT TEXT */}
            <div className="relative h-[320px] md:h-[360px] overflow-hidden">
              <AnimatePresence initial={false} custom={direction}>
                <motion.div
                  key={index}
                  custom={direction}
                  variants={slideVariants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{ duration: 0.45 }}
                  className="absolute inset-0"
                >
                  <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-4">
                    {t.title}
                  </h3>

                  <p className="text-gray-600 leading-relaxed mb-8 text-lg">
                    {t.description}
                  </p>

                  <div>
                    <p className="font-semibold text-gray-900 text-lg">{t.name}</p>
                    <p className="text-red-600 text-sm font-medium">{t.role}</p>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* RIGHT IMAGE */}
            <div className="relative h-[300px] md:h-[360px] overflow-hidden flex justify-center items-center">
              <AnimatePresence initial={false} custom={direction}>
                <motion.div
                  key={index}
                  custom={direction}
                  variants={slideVariants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{ duration: 0.45 }}
                  className="absolute inset-0 flex justify-center items-center"
                >
                  <div className="w-full h-full max-w-sm rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
                    <img
                      src={t.image}
                      alt="testimonial"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-center gap-4 mt-12">
            <button
              onClick={prev}
              className="h-12 w-12 rounded-full bg-red-500 flex items-center justify-center hover:bg-red-600 transition shadow-md"
            >
              <FaChevronLeft className="text-white" />
            </button>

            <button
              onClick={next}
              className="h-12 w-12 rounded-full bg-red-500 flex items-center justify-center hover:bg-red-600 transition shadow-md"
            >
              <FaChevronRight className="text-white" />
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};
